import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Link } from '@inertiajs/react';
import { BookOpenText, Phone, HelpCircle, Settings, ExternalLink } from 'lucide-react';
import { cn } from '@/lib/utils';

export function ResourcesCard() {
  const resources = [
    {
      title: 'Guida al percorso',
      description: 'Come utilizzare al meglio la piattaforma',
      icon: BookOpenText,
      href: '/guide', // TODO: Implement guide page
      color: 'text-blue-600',
      bgColor: 'bg-blue-100 dark:bg-blue-900/20',
      external: false,
    },
    {
      title: 'Contatti emergenza',
      description: 'Numeri utili per situazioni di crisi',
      icon: Phone,
      href: '/emergency-contacts', // TODO: Implement emergency contacts page
      color: 'text-red-600',
      bgColor: 'bg-red-100 dark:bg-red-900/20',
      external: false,
    },
    {
      title: 'FAQ',
      description: 'Domande frequenti e risposte',
      icon: HelpCircle,
      href: '/faq', // TODO: Implement FAQ page
      color: 'text-green-600',
      bgColor: 'bg-green-100 dark:bg-green-900/20',
      external: false,
    },
    {
      title: 'Impostazioni',
      description: 'Gestisci il tuo profilo e preferenze',
      icon: Settings,
      href: '/patients/profile',
      color: 'text-purple-600',
      bgColor: 'bg-purple-100 dark:bg-purple-900/20',
      external: false,
    },
  ];

  return (
    <Card className="border-0 shadow-sm">
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-lg">
          <div className="p-2 rounded-lg bg-gray-100 dark:bg-gray-800">
            <BookOpenText className="h-5 w-5 text-gray-600 dark:text-gray-400" />
          </div>
          Risorse utili
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {resources.map((resource, index) => {
            const ResourceIcon = resource.icon;

            const resourceContent = (
              <div className={cn(
                'p-4 rounded-lg border border-gray-200 dark:border-gray-700',
                'hover:shadow-md transition-all duration-200',
                'hover:scale-[1.02] cursor-pointer',
                'group'
              )}>
                <div className="flex flex-col items-center text-center space-y-3">
                  <div className={cn('p-3 rounded-lg', resource.bgColor)}>
                    <ResourceIcon className={cn('h-6 w-6', resource.color)} />
                  </div>
                  <div>
                    <h3 className="font-medium text-gray-900 dark:text-white group-hover:text-blue-600 dark:group-hover:text-blue-400 transition-colors">
                      {resource.title}
                      {resource.external && (
                        <ExternalLink className="inline h-3 w-3 ml-1" />
                      )}
                    </h3>
                    <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">
                      {resource.description}
                    </p>
                  </div>
                </div>
              </div>
            );

            return (
              <div key={index}>
                {resource.external ? (
                  <a
                    href={resource.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="block"
                  >
                    {resourceContent}
                  </a>
                ) : (
                  <Link href={resource.href} className="block">
                    {resourceContent}
                  </Link>
                )}
              </div>
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
}
